export default {
    aside_update_now: "Actualizar Ahora",
    aside_smart_card: "Tarjeta Inteligente",
    aside_forms: "Formularios",
    aside_list: "Lista",
    aside_alert_response: "Alerta y Respuesta",
    aside_notifications: "Notificaciones",
    aside_btn_call_link: "Enlace de Llamada",
    aside_bstore: "bStore",
    aside_products: "Productos",
    aside_orders: "Pedidos",
    aside_todays_deals: "Ofertas del Día",
    aside_plugins: "Complementos",
    aside_projects: "Proyectos",
    aside_bmenu: "bMenu",
    aside_setup: "Configuración",
}
